const logoUrl = "/img/logo-w-electric.png";

export const imageLibrary = {
  hero:
    "https://images.unsplash.com/photo-1595856619767-ab739fa7daae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBvbiUyMHN3aXRjaGJvYXJkJTIwc2FmZXR5JTIwZ2VhcnxlbnwwfHx8fDE3NzMxMDMyMDN8MA&ixlib=rb-4.1.0&q=85",
  substation:
    "https://images.unsplash.com/photo-1759138884006-0903cf0af1b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxoaWdoJTIwdm9sdGFnZSUyMHRyYW5zZm9ybWVyJTIwZWxlY3RyaWNhbCUyMHBvd2VyJTIwZ3JpZHxlbnwwfHx8fDE3NzMxMDMyMDF8MA&ixlib=rb-4.1.0&q=85",
  panels:
    "/img/1.png",
  technician:
    "https://images.pexels.com/photos/13875374/pexels-photo-13875374.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  industrial:
    "/img/2.png",
  transformer:
    "https://images.pexels.com/photos/7867332/pexels-photo-7867332.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const companyInfo = {
  name: "W-Electric Engenharia Elétrica",
  shortName: "W-Electric",
  logoUrl,
  phoneDisplay: "(11) 99111-4643",
  phoneDigits: "5511991114643",
  phoneHref: "tel:+5511991114643",
  email: "contatowelectric@gmail.com",
  emailHref: "mailto:contatowelectric@gmail.com",
  city: "São Paulo",
  region: "SP",
  country: "BR",
  serviceArea: "São Paulo e região metropolitana",
};

export const buildWhatsAppUrl = (
  message = "Olá, gostaria de solicitar um orçamento para serviços de engenharia elétrica."
) => `https://wa.me/${companyInfo.phoneDigits}?text=${encodeURIComponent(message)}`;

export const homeSeo = {
  title: "W-Electric Engenharia Elétrica | Manutenção de Cabine Primária em São Paulo",
  description:
    "Empresa especializada em manutenção elétrica industrial, subestações e cabine primária em São Paulo. Ensaios elétricos, comissionamento de painéis e testes em transformadores.",
};

export const heroSlides = [
  imageLibrary.hero,
  imageLibrary.substation,
  imageLibrary.industrial,
  imageLibrary.panels,
];

export const serviceDropdownLinks = [
  { id: "cabine-primaria", name: "Cabine Primária", path: "/manutencao-cabine-primaria" },
  { id: "ensaios-eletricos", name: "Ensaios Elétricos", path: "/ensaios-eletricos" },
  { id: "comissionamento", name: "Comissionamento", path: "/comissionamento-paineis" },
  { id: "manutencao-industrial-sp", name: "Manutenção Industrial SP", path: "/manutencao-eletrica-industrial-sp" },
];

export const mainNavigationLinks = [
  { name: "Home", path: "/" },
  { name: "Serviços", path: "/servicos", hasDropdown: true },
  { name: "Sobre", path: "/sobre" },
  { name: "Contato", path: "/contato" },
];

export const navigationLinks = [
  { name: "Home", path: "/" },
  { name: "Serviços", path: "/servicos" },
  { name: "Cabine Primária", path: "/manutencao-cabine-primaria" },
  { name: "Ensaios Elétricos", path: "/ensaios-eletricos" },
  { name: "Comissionamento", path: "/comissionamento-paineis" },
  { name: "Manutenção Industrial SP", path: "/manutencao-eletrica-industrial-sp" },
  { name: "Sobre", path: "/sobre" },
  { name: "Contato", path: "/contato" },
];

export const primaryServices = [
  {
    title: "Manutenção de Cabine Primária",
    summary:
      "Plano preventivo e corretivo para garantir segurança operacional, disponibilidade e conformidade normativa.",
    eyebrow: "Alta tensão",
    path: "/manutencao-cabine-primaria",
    image: imageLibrary.substation,
  },
  {
    title: "Ensaios Elétricos em Subestação",
    summary:
      "Testes especializados em transformadores, disjuntores e circuitos de proteção para diagnóstico preciso.",
    eyebrow: "Diagnóstico técnico",
    path: "/ensaios-eletricos",
    image: imageLibrary.transformer,
  },
  {
    title: "Comissionamento de Painéis",
    summary:
      "Validação funcional, teste ponto a ponto e verificação de intertravamentos antes da energização.",
    eyebrow: "Entrega segura",
    path: "/comissionamento-paineis",
    image: imageLibrary.panels,
  },
  {
    title: "Consultoria Técnica",
    summary:
      "Apoio de engenharia para diagnósticos, adequações normativas e decisões técnicas em campo.",
    eyebrow: "Engenharia aplicada",
    path: "/servicos#consultoria-tecnica",
    image: imageLibrary.industrial,
  },
  {
    title: "Laudos e Inspeções",
    summary:
      "Relatórios técnicos, inspeções visuais e documentações para auditorias, ARTs e regularização elétrica.",
    eyebrow: "Conformidade",
    path: "/servicos#laudos-e-inspecoes",
    image: imageLibrary.technician,
  },
  {
    title: "Fiscalização Técnica",
    summary:
      "Acompanhamento técnico de obras, montagem eletromecânica e comissionamento para reduzir retrabalho.",
    eyebrow: "Controle de execução",
    path: "/servicos#fiscalizacao-tecnica",
    image: imageLibrary.hero,
  },
];

export const condominiumSolutions = [
  {
    title: "Manutenção preventiva em painéis e cabines",
    description:
      "Evita falhas, reduz riscos e aumenta a vida útil dos equipamentos críticos de alimentação elétrica.",
    badges: ["NR10", "NR12", "NBR5410"],
  },
  {
    title: "Termografia em quadros e barramentos",
    description:
      "Detecção de pontos críticos antes de panes ou incêndios com análise técnica e relatório fotográfico.",
  },
  {
    title: "Instalação de carregadores veiculares (Wallbox)",
    description:
      "Projeto, dimensionamento e instalação para condomínios com foco em segurança e expansão futura.",
  },
  {
    title: "Laudos técnicos, ARTs e inspeções",
    description:
      "Regularização elétrica, SPDA, aterramento e documentos técnicos para síndicos e administradoras.",
  },
  {
    title: "Revisão e modernização de quadros elétricos",
    description:
      "Troca de disjuntores antigos, barramentos oxidados e melhorias de proteção para reduzir indisponibilidade.",
  },
];

export const differentials = [
  "Equipe especializada em engenharia elétrica",
  "Equipamentos profissionais de medição",
  "Relatórios técnicos completos",
  "Atendimento em São Paulo",
  "Segurança e conformidade normativa",
];

export const testimonials = [
  {
    company: "Grupo Atlas Condomínios",
    quote:
      "A W-Electric estruturou a manutenção preventiva da nossa cabine primária com organização, segurança e excelente comunicação técnica.",
    author: "Marcos S., gestor predial",
  },
  {
    company: "Indústria Nova Linha",
    quote:
      "Os ensaios elétricos foram conduzidos com precisão e os relatórios nos deram clareza para tomar decisões rápidas sem parar a operação.",
    author: "Fernanda P., coordenação industrial",
  },
  {
    company: "Conecta Facilities",
    quote:
      "Comissionamento impecável, cronograma respeitado e suporte técnico firme do início ao fim da entrega dos painéis.",
    author: "Rafael T., engenharia de manutenção",
  },
];

export const operationalStats = [
  { value: "SP", label: "Atendimento focado em São Paulo" },
  { value: "NR10", label: "Conformidade e segurança operacional" },
  { value: "24/7", label: "Prontidão para ativos críticos" },
  { value: "ART", label: "Documentação e rastreabilidade técnica" },
];

export const servicePages = {
  cabinePrimaria: {
    path: "/manutencao-cabine-primaria",
    menuName: "Cabine Primária",
    title: "Manutenção de Cabine Primária em São Paulo",
    seoTitle:
      "Manutenção de Cabine Primária em São Paulo | W-Electric Engenharia Elétrica",
    metaDescription:
      "Manutenção de cabine primária em São Paulo com inspeção geral, limpeza técnica, reaperto de conexões, ensaios em disjuntores, testes em TC e TP e verificação de relés.",
    keyword: "manutenção de cabine primária em São Paulo",
    image: imageLibrary.substation,
    intro:
      "A manutenção preventiva da cabine primária reduz riscos de falhas, preserva a vida útil dos equipamentos e mantém o sistema preparado para operar com segurança em ambientes industriais e corporativos.",
    activities: [
      "Inspeção geral da cabine",
      "Limpeza técnica",
      "Reaperto de conexões",
      "Ensaios em disjuntores",
      "Testes em TC e TP",
      "Verificação de relés de proteção",
    ],
    process: [
      {
        title: "Diagnóstico inicial",
        description:
          "Levantamento técnico do estado da cabine, condições de isolamento, aquecimento e histórico operacional.",
      },
      {
        title: "Intervenção preventiva",
        description:
          "Limpeza, reaperto, ajustes, testes em dispositivos de proteção e correções programadas para evitar paradas inesperadas.",
      },
      {
        title: "Relatório e recomendações",
        description:
          "Entrega de relatório técnico com evidências, pendências encontradas e prioridades para manutenção futura.",
      },
    ],
    benefits: [
      "Redução de riscos de desligamento inesperado",
      "Mais segurança para pessoas e ativos críticos",
      "Aumento da confiabilidade da subestação",
      "Melhor controle de conformidade normativa",
    ],
  },
  ensaiosEletricos: {
    path: "/ensaios-eletricos",
    menuName: "Ensaios Elétricos",
    title: "Ensaios Elétricos em Subestação",
    seoTitle: "Ensaios Elétricos em Subestação | W-Electric Engenharia Elétrica",
    metaDescription:
      "Ensaios elétricos em subestação com ensaio de isolação, relação de transformação, resistência de enrolamento, testes em transformadores e relés de proteção.",
    keyword: "ensaios elétricos em subestação",
    image: imageLibrary.transformer,
    intro:
      "Os ensaios elétricos identificam anomalias antes que elas comprometam a confiabilidade do sistema. A atuação é orientada por procedimentos técnicos, instrumentos calibrados e interpretação de resultados com foco em decisão segura.",
    activities: [
      "Ensaio de isolação",
      "Relação de transformação",
      "Resistência de enrolamento",
      "Testes em transformadores",
      "Testes em relés de proteção",
    ],
    process: [
      {
        title: "Planejamento do ensaio",
        description:
          "Definição do escopo conforme criticidade do ativo, janela de manutenção e histórico de ocorrências.",
      },
      {
        title: "Execução com rastreabilidade",
        description:
          "Aplicação dos testes com registros, comparativos e observação criteriosa dos limites operacionais.",
      },
      {
        title: "Laudo técnico",
        description:
          "Conclusões objetivas com recomendações de continuidade operacional, manutenção corretiva ou retrofit.",
      },
    ],
    benefits: [
      "Detecção precoce de degradação de isolamento",
      "Validação do desempenho de transformadores",
      "Maior previsibilidade de manutenção",
      "Suporte a auditorias e planejamento técnico",
    ],
  },
  comissionamentoPaineis: {
    path: "/comissionamento-paineis",
    menuName: "Comissionamento",
    title: "Comissionamento de Painéis Elétricos",
    seoTitle:
      "Comissionamento de Painéis Elétricos | W-Electric Engenharia Elétrica",
    metaDescription:
      "Comissionamento de painéis elétricos com teste ponto a ponto, testes funcionais, verificação de intertravamentos e TAC de painéis.",
    keyword: "comissionamento de painéis elétricos",
    image: imageLibrary.panels,
    intro:
      "O comissionamento garante que o painel elétrico seja entregue pronto para operar com segurança, lógica validada, intertravamentos conferidos e documentação coerente com o projeto executivo.",
    activities: [
      "Teste ponto a ponto",
      "Testes funcionais",
      "Verificação de intertravamentos",
      "TAC de painéis elétricos",
    ],
    process: [
      {
        title: "Conferência elétrica e documental",
        description:
          "Análise do projeto, identificação de componentes, bornes, cabos e sequência lógica de operação.",
      },
      {
        title: "Validação funcional",
        description:
          "Teste de entradas, saídas, comandos, alarmes, intertravamentos e resposta do sistema em cenários operacionais.",
      },
      {
        title: "Liberação para energização",
        description:
          "Emissão de relatório e pendências críticas para garantir entrega segura ao cliente final.",
      },
    ],
    benefits: [
      "Redução de falhas no start-up",
      "Entrega técnica mais confiável",
      "Menor retrabalho em campo",
      "Segurança para operação e manutenção",
    ],
  },
};

export const servicesPageSections = [
  {
    id: "consultoria-tecnica",
    title: "Consultoria Técnica",
    description:
      "Suporte em análises, pareceres, adequações e soluções para condomínios, indústrias e empresas com sistemas elétricos críticos.",
    bullets: [
      "Diagnóstico de falhas recorrentes",
      "Estudos e recomendações para adequação",
      "Apoio técnico para decisões de investimento",
    ],
  },
  {
    id: "laudos-e-inspecoes",
    title: "Laudos e Inspeções",
    description:
      "Documentação técnica com linguagem clara, rastreabilidade e suporte para auditorias, síndicos e gestores de manutenção.",
    bullets: [
      "Laudos técnicos e inspeções programadas",
      "ARTs e documentação fotográfica",
      "Avaliação de SPDA, aterramento e quadros",
    ],
  },
  {
    id: "fiscalizacao-tecnica",
    title: "Fiscalização Técnica",
    description:
      "Acompanhamento de obras e montagens para garantir aderência ao projeto, segurança na execução e qualidade final da instalação.",
    bullets: [
      "Fiscalização de montagens elétricas",
      "Validação de materiais e execução",
      "Apoio ao start-up e entrega técnica",
    ],
  },
];

export const localSeoPoints = [
  "manutenção de cabine primária",
  "ensaios elétricos",
  "manutenção de subestações",
  "comissionamento de painéis",
];

export const localSeoCoverage = [
  "Condomínios residenciais e corporativos",
  "Indústrias e galpões logísticos",
  "Centros empresariais e facilities",
  "São Paulo capital e região metropolitana",
];

export const aboutHighlights = [
  "Experiência em subestações elétricas",
  "Ensaios em equipamentos e sistemas de proteção",
  "Comissionamento de sistemas e painéis elétricos",
  "Projetos elétricos industriais com visão de campo",
];

export const footerStatement =
  "Engenharia elétrica com foco em confiabilidade, segurança operacional e atendimento técnico para ativos críticos em São Paulo.";